import { render, staticRenderFns } from "./Podcast.vue?vue&type=template&id=0195cdca&"
import script from "./Podcast.vue?vue&type=script&lang=js&"
export * from "./Podcast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports